import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import type { AddTableSectionParams } from 'src/features/templateEdit/section/table/model'
import { addTableSection as addTableSectionAction } from 'src/state/ducks/templates/actions'
import { toggleAudit } from 'src/state/ducks/templates/editTemplate/actions'
import type { RootState } from 'src/state/store'
import { TableSectionAddConfirmDialog } from './TableSectionAddConfirmDialog'

/**
 * 「表を追加」の実行ハンドラと確認ダイアログを返す。
 * 表を含むひな形ではカイゼン機能を使用できないため、カイゼン機能が ON の場合は
 * 確認ダイアログを挟み、OK ならカイゼン機能を自動で OFF にしてから表を追加する。
 * 呼び出し側は confirmDialog を描画すること。
 */
export const useAddTableSection = () => {
  const dispatch = useDispatch()
  const isAudit = useSelector(
    (state: RootState) => state.templatesState.editTemplate.isAudit,
  )
  // カイゼン機能 OFF の確認待ちになっている追加パラメータ。値がある間ダイアログを表示する
  const [pendingParams, setPendingParams] = useState<AddTableSectionParams>()

  const addTableSection = (params: AddTableSectionParams) => {
    if (!isAudit) {
      dispatch(addTableSectionAction(params))
      return
    }
    setPendingParams(params)
  }

  const confirmDialog = pendingParams && (
    <TableSectionAddConfirmDialog
      open
      onCancel={() => setPendingParams(undefined)}
      onOk={() => {
        dispatch(toggleAudit(false))
        dispatch(addTableSectionAction(pendingParams))
        setPendingParams(undefined)
      }}
    />
  )

  return { addTableSection, confirmDialog }
}
